export default {
    matchInfo: {
        id: '7c2f1r3fe7code6ijoi1xzh1w',
        coverageLevel: '15',
        date: '2022-08-28Z',
        time: '15:30:00Z',
        localDate: '2022-08-28',
        localTime: '16:30:00',
        week: '4',
        numberOfPeriods: 2,
        periodLength: 45,
        lastUpdated: '2022-08-28T17:32:51Z',
        description: 'Nottingham Forest vs Tottenham Hotspur',
        sport: {
            id: '289u5typ3vp4ifwh5thalohmq',
            name: 'Soccer',
        },
        ruleset: {
            id: '79plas4983031idr6vw83nuel',
            name: 'Men',
        },
        competition: {
            id: '2kwbbcootiqqgmrzs6o5inle5',
            name: 'Premier League',
            competitionCode: 'EPL',
            competitionFormat: 'Domestic league',
            country: {
                id: '1fk5l4hkqk12i7zske6mcqju6',
                name: 'England',
            },
        },
        tournamentCalendar: {
            id: '80foo89mm28qjvyhjzlpwj28k',
            startDate: '2022-08-05Z',
            endDate: '2023-05-28Z',
            name: '2022/2023',
        },
        stage: {
            id: '80qbeanalyj5cvxikkq351iqc',
            formatId: 'e2q01r9o9jwiq1fls93d1sslx',
            startDate: '2022-08-05Z',
            endDate: '2023-05-28Z',
            name: 'Regular Season',
        },
        contestant: [
            {
                id: '1qtaiy11gswx327s0vkibf70n',
                name: 'Nottingham Forest',
                shortName: 'Nottm Forest',
                officialName: 'Nottingham Forest FC',
                code: 'NFO',
                position: 'home',
                country: {
                    id: '1fk5l4hkqk12i7zske6mcqju6',
                    name: 'England',
                },
            },
            {
                id: '22doj4sgsocqpxw45h607udje',
                name: 'Tottenham Hotspur',
                shortName: 'Tottenham',
                officialName: 'Tottenham Hotspur FC',
                code: 'TOT',
                position: 'away',
                country: {
                    id: '1fk5l4hkqk12i7zske6mcqju6',
                    name: 'England',
                },
            },
        ],
        venue: {
            id: '6ccyj8bk3iv2mc01xe5rtch3r',
            neutral: 'no',
            longName: 'The City Ground',
            shortName: 'The City Ground',
        },
    },
    liveData: {
        matchDetails: {
            periodId: 14,
            matchStatus: 'Played',
            winner: 'away',
            matchLengthMin: 99,
            matchLengthSec: 57,
            period: [
                {
                    id: 1,
                    start: '2022-08-28T15:30:17Z',
                    end: '2022-08-28T16:16:23Z',
                    lengthMin: 46,
                    lengthSec: 6,
                },
                {
                    id: 2,
                    start: '2022-08-28T16:31:24Z',
                    end: '2022-08-28T17:25:15Z',
                    lengthMin: 53,
                    lengthSec: 51,
                },
            ],
            scores: {
                ht: {
                    home: 0,
                    away: 1,
                },
                ft: {
                    home: 0,
                    away: 2,
                },
                total: {
                    home: 0,
                    away: 2,
                },
            },
        },
        goal: [
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                periodId: 1,
                timeMin: 5,
                timeMinSec: '4:58',
                lastUpdated: '2022-08-28T15:36:23Z',
                timestamp: '2022-08-28T15:35:15Z',
                type: 'G',
                scorerId: 'b9g4qurpll4wizajo95c406hh',
                scorerName: 'H. Kane',
                assistPlayerId: 'dlf31m2lrfl0biop1demgvh7t',
                assistPlayerName: 'D. Kulusevski',
                optaEventId: '2452502131',
                homeScore: 0,
                awayScore: 1,
            },
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                periodId: 2,
                timeMin: 81,
                timeMinSec: '80:34',
                lastUpdated: '2022-08-28T17:08:14Z',
                timestamp: '2022-08-28T17:06:58Z',
                type: 'G',
                scorerId: 'b9g4qurpll4wizajo95c406hh',
                scorerName: 'H. Kane',
                assistPlayerId: 'c5zmr0m17riujelm4up44etih',
                assistPlayerName: 'Richarlison',
                optaEventId: '2452583845',
                homeScore: 0,
                awayScore: 2,
            },
        ],
        missedPen: [
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                periodId: 2,
                timeMin: 56,
                timeMinSec: '55:32',
                lastUpdated: '2022-08-28T16:42:34Z',
                timestamp: '2022-08-28T16:41:57Z',
                type: 'PM',
                playerId: 'b9g4qurpll4wizajo95c406hh',
                playerName: 'H. Kane',
                optaEventId: '2452561675',
            },
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 56,
                timeMinSec: '55:32',
                lastUpdated: '2022-08-28T16:42:34Z',
                type: 'PS',
                playerId: '5z8ycnd0smdkumi5fgtzf7c9h',
                playerName: 'D. Henderson',
                optaEventId: '2452561675',
            },
        ],
        card: [
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 54,
                timeMinSec: '53:10',
                lastUpdated: '2022-08-28T16:41:15Z',
                timestamp: '2022-08-28T16:39:34Z',
                type: 'YC',
                playerId: 'av7e2wk5ub7qnh3sqcvssvh79',
                playerName: 'S. Cook',
                optaEventId: '2452560733',
                cardReason: 'Handball',
            },
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 58,
                timeMinSec: '57:14',
                lastUpdated: '2022-08-28T16:43:44Z',
                timestamp: '2022-08-28T16:43:38Z',
                type: 'YC',
                playerId: '1tuivl8zdnsaz8vbed2z582qx',
                playerName: 'J. Worrall',
                optaEventId: '2452563465',
                cardReason: 'Foul',
            },
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 61,
                timeMinSec: '60:04',
                lastUpdated: '2022-08-28T16:46:35Z',
                timestamp: '2022-08-28T16:46:29Z',
                type: 'YC',
                playerId: '12cgiy0t282ywdbr5j78hrxsl',
                playerName: 'S. McKenna',
                optaEventId: '2452566523',
                cardReason: 'Foul',
            },
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 73,
                timeMinSec: '72:18',
                lastUpdated: '2022-08-28T16:58:50Z',
                timestamp: '2022-08-28T16:58:42Z',
                type: 'YC',
                playerId: 'dcq0nu7mmecab5djjwg0n8ktm',
                playerName: "L. O'Brien",
                optaEventId: '2452576759',
                cardReason: 'Foul',
            },
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                periodId: 2,
                timeMin: 82,
                timeMinSec: '81:40',
                lastUpdated: '2022-08-28T17:08:31Z',
                timestamp: '2022-08-28T17:08:05Z',
                type: 'YC',
                playerId: 'b9g4qurpll4wizajo95c406hh',
                playerName: 'H. Kane',
                optaEventId: '2452585265',
                cardReason: 'Excessive celebration',
            },
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 84,
                timeMinSec: '83:17',
                lastUpdated: '2022-08-28T17:09:55Z',
                timestamp: '2022-08-28T17:09:42Z',
                type: 'YC',
                playerId: 'a6m9jcx0e4l6krv1u0pbfuoyd',
                playerName: 'C. Kouyaté',
                optaEventId: '2452586569',
                cardReason: 'Foul',
            },
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 85,
                timeMinSec: '84:35',
                lastUpdated: '2022-08-28T17:11:11Z',
                timestamp: '2022-08-28T17:10:59Z',
                type: 'YC',
                playerId: '1l228p52d8wdf8qhfxqu8rca',
                playerName: 'B. Johnson',
                optaEventId: '2452587877',
                cardReason: 'Foul',
            },
        ],
        substitute: [
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 69,
                timeMinSec: '68:49',
                lastUpdated: '2022-08-28T16:55:21Z',
                timestamp: '2022-08-28T16:55:13Z',
                playerOnId: '3ztcz2dgfniqv141w7xsky7zd',
                playerOnName: 'E. Dennis',
                playerOffId: '5f72vvw62zdlyrj3mwux2udat',
                playerOffName: 'J. Lingard',
                subReason: 'Tactical',
            },
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                periodId: 2,
                timeMin: 74,
                timeMinSec: '73:02',
                lastUpdated: '2022-08-28T16:59:34Z',
                timestamp: '2022-08-28T16:59:26Z',
                playerOnId: 'cag3gzjcv8erx3zpp2lidzcvd',
                playerOnName: 'R. Sessegnon',
                playerOffId: '2gsq05yyxwe4f8t79j6d49q6t',
                playerOffName: 'I. Perišić',
                subReason: 'Tactical',
            },
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                periodId: 2,
                timeMin: 74,
                timeMinSec: '73:23',
                lastUpdated: '2022-08-28T16:59:56Z',
                timestamp: '2022-08-28T16:59:47Z',
                playerOnId: 'c5zmr0m17riujelm4up44etih',
                playerOnName: 'Richarlison',
                playerOffId: '12ekwo6gbza410blv4b4r7ydx',
                playerOffName: 'Son Heung-Min',
                subReason: 'Tactical',
            },
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 75,
                timeMinSec: '74:23',
                lastUpdated: '2022-08-28T17:00:54Z',
                timestamp: '2022-08-28T17:00:48Z',
                playerOnId: '19nlw3sa0khwz0el4wqc7zrp',
                playerOnName: 'R. Freuler',
                playerOffId: 'dcq0nu7mmecab5djjwg0n8ktm',
                playerOffName: "L. O'Brien",
                subReason: 'Tactical',
            },
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 75,
                timeMinSec: '74:28',
                lastUpdated: '2022-08-28T17:01:02Z',
                timestamp: '2022-08-28T17:00:52Z',
                playerOnId: 'a6m9jcx0e4l6krv1u0pbfuoyd',
                playerOnName: 'C. Kouyaté',
                playerOffId: 'ece7xph4emgawvh7mr56319ex',
                playerOffName: 'R. Yates',
                subReason: 'Tactical',
            },
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 75,
                timeMinSec: '74:44',
                lastUpdated: '2022-08-28T17:01:15Z',
                timestamp: '2022-08-28T17:01:08Z',
                playerOnId: '55eiicx10oqok1601fqyovt1x',
                playerOnName: 'T. Awoniyi',
                playerOffId: 'av7e2wk5ub7qnh3sqcvssvh79',
                playerOffName: 'S. Cook',
                subReason: 'Tactical',
            },
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                periodId: 2,
                timeMin: 83,
                timeMinSec: '82:11',
                lastUpdated: '2022-08-28T17:08:40Z',
                timestamp: '2022-08-28T17:08:35Z',
                playerOnId: '1g15ehziupxnsy1kvl3pqmbc9',
                playerOnName: 'Y. Bissouma',
                playerOffId: 'dlf31m2lrfl0biop1demgvh7t',
                playerOffName: 'D. Kulusevski',
                subReason: 'Tactical',
            },
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 91,
                timeMinSec: '90:02',
                lastUpdated: '2022-08-28T17:16:36Z',
                timestamp: '2022-08-28T17:16:27Z',
                playerOnId: '8kfciybd6filv663ebckuerjd',
                playerOnName: 'S. Surridge',
                playerOffId: '1l228p52d8wdf8qhfxqu8rca',
                playerOffName: 'B. Johnson',
                subReason: 'Tactical',
            },
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                periodId: 2,
                timeMin: 91,
                timeMinSec: '90:37',
                lastUpdated: '2022-08-28T17:17:11Z',
                timestamp: '2022-08-28T17:17:01Z',
                playerOnId: '9irgn82qm11logbhup51rg5wp',
                playerOnName: 'D. Spence',
                playerOffId: '3wp8fuk07m1ph1fpmbqe7tf55',
                playerOffName: 'R. Bentancur',
                subReason: 'Injury',
            },
        ],
        VAR: [
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                periodId: 2,
                timeMin: 55,
                timeMinSec: '54:46',
                lastUpdated: '2022-08-28T16:41:20Z',
                timestamp: '2022-08-28T16:41:10Z',
                type: 'Card upgrade',
                decision: 'Confirmed',
                outcome: 'No change',
                playerId: 'av7e2wk5ub7qnh3sqcvssvh79',
                playerName: 'S. Cook',
                optaEventId: '2452560939',
            },
        ],
        lineUp: [
            {
                contestantId: '1qtaiy11gswx327s0vkibf70n',
                formationUsed: '3421',
                teamOfficial: {
                    id: '7qb4jzx7wrt2syeio63jpjtgp',
                    firstName: 'Steven David',
                    lastName: 'Cooper',
                    type: 'manager',
                },
                stat: [
                    {
                        fh: '412',
                        sh: '330',
                        type: 'touches',
                        value: '742',
                    },
                    {
                        fh: '5',
                        sh: '7',
                        type: 'wonTackle',
                        value: '12',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'accurateKeeperThrows',
                        value: '2',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'accurateCornersIntobox',
                        value: '2',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attFreekickTotal',
                        value: '1',
                    },
                    {
                        fh: '11',
                        sh: '5',
                        type: 'accurateThrows',
                        value: '16',
                    },
                    {
                        fh: '14',
                        sh: '14',
                        type: 'accurateLongBalls',
                        value: '28',
                    },
                    {
                        fh: '0',
                        sh: '4',
                        type: 'attemptedTackleFoul',
                        value: '4',
                    },
                    {
                        fh: '25',
                        sh: '12',
                        type: 'penAreaEntries',
                        value: '37',
                    },
                    {
                        fh: '16',
                        sh: '11',
                        type: 'possWonMid3rd',
                        value: '27',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'attOboxMiss',
                        value: '1',
                    },
                    {
                        fh: '11',
                        sh: '7',
                        type: 'totalCrossNocorner',
                        value: '18',
                    },
                    {
                        fh: '5',
                        sh: '6',
                        type: 'interception',
                        value: '11',
                    },
                    {
                        fh: '2',
                        sh: '4',
                        type: 'wonCorners',
                        value: '6',
                    },
                    {
                        fh: '89',
                        sh: '64',
                        type: 'rightsidePass',
                        value: '153',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'handBall',
                        value: '2',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'penaltySave',
                        value: '1',
                    },
                    {
                        fh: '8',
                        sh: '4',
                        type: 'attOpenplay',
                        value: '12',
                    },
                    {
                        fh: '329',
                        sh: '228',
                        type: 'totalPass',
                        value: '557',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'freekickCross',
                        value: '1',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'goodHighClaim',
                        value: '1',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'penaltyFaced',
                        value: '1',
                    },
                    {
                        fh: '2',
                        sh: '0',
                        type: 'headClearance',
                        value: '2',
                    },
                    {
                        fh: '17',
                        sh: '24',
                        type: 'duelLost',
                        value: '41',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'totalKeeperSweeper',
                        value: '2',
                    },
                    {
                        fh: '34',
                        sh: '24',
                        type: 'ballRecovery',
                        value: '58',
                    },
                    {
                        fh: '81',
                        sh: '56',
                        type: 'possLostCtrl',
                        value: '137',
                    },
                    {
                        fh: '4',
                        sh: '3',
                        type: 'blockedScoringAtt',
                        value: '7',
                    },
                    {
                        fh: '8',
                        sh: '8',
                        type: 'unsuccessfulTouch',
                        value: '16',
                    },
                    {
                        fh: '4',
                        sh: '5',
                        type: 'successfulPutThrough',
                        value: '9',
                    },
                    {
                        fh: '21',
                        sh: '15',
                        type: 'totalChippedPass',
                        value: '36',
                    },
                    {
                        fh: '6',
                        sh: '8',
                        type: 'totalContest',
                        value: '14',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'goalsConcededObox',
                        value: '1',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'interceptionsInBox',
                        value: '1',
                    },
                    {
                        fh: '3',
                        sh: '5',
                        type: 'attIboxMiss',
                        value: '8',
                    },
                    {
                        fh: '320',
                        sh: '211',
                        type: 'openPlayPass',
                        value: '531',
                    },
                    {
                        fh: '126',
                        sh: '64',
                        type: 'totalFinalThirdPasses',
                        value: '190',
                    },
                    {
                        fh: '1',
                        sh: '3',
                        type: 'dispossessed',
                        value: '4',
                    },
                    {
                        fh: '2',
                        sh: '9',
                        type: 'fkFoulLost',
                        value: '11',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'attOboxTarget',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'ontargetScoringAtt',
                        value: '1',
                    },
                    {
                        fh: '33',
                        sh: '24',
                        type: 'totalLongBalls',
                        value: '57',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'goalsConcededIbox',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '3',
                        type: 'accurateCross',
                        value: '4',
                    },
                    {
                        fh: '81',
                        sh: '56',
                        type: 'possLostAll',
                        value: '137',
                    },
                    {
                        fh: '92',
                        sh: '48',
                        type: 'successfulFinalThirdPasses',
                        value: '140',
                    },
                    {
                        fh: '6',
                        sh: '6',
                        type: 'attAssistOpenplay',
                        value: '12',
                    },
                    {
                        fh: '0',
                        sh: '4',
                        type: 'saves',
                        value: '4',
                    },
                    {
                        fh: '2',
                        sh: '3',
                        type: 'crosses18yardplus',
                        value: '5',
                    },
                    {
                        fh: '1',
                        sh: '2',
                        type: 'attHdTotal',
                        value: '3',
                    },
                    {
                        fh: '2',
                        sh: '2',
                        type: 'accurateLayoffs',
                        value: '4',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attCmissRight',
                        value: '1',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'penaltyConceded',
                        value: '1',
                    },
                    {
                        fh: '5',
                        sh: '6',
                        type: 'interceptionWon',
                        value: '11',
                    },
                    {
                        fh: '43',
                        sh: '27',
                        type: 'longPassOwnToOpp',
                        value: '70',
                    },
                    {
                        fh: '9',
                        sh: '1',
                        type: 'possWonAtt3rd',
                        value: '10',
                    },
                    {
                        fh: '21',
                        sh: '31',
                        type: 'duelWon',
                        value: '52',
                    },
                    {
                        fh: '108',
                        sh: '109',
                        type: 'totalBackZonePass',
                        value: '217',
                    },
                    {
                        fh: '2',
                        sh: '2',
                        type: 'totalLayoffs',
                        value: '4',
                    },
                    {
                        fh: '5',
                        sh: '7',
                        type: 'blockedPass',
                        value: '12',
                    },
                    {
                        fh: '24',
                        sh: '19',
                        type: 'longPassOwnToOppSuccess',
                        value: '43',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'attLfTarget',
                        value: '1',
                    },
                    {
                        fh: '4',
                        sh: '3',
                        type: 'totalClearance',
                        value: '7',
                    },
                    {
                        fh: '1',
                        sh: '4',
                        type: 'outfielderBlock',
                        value: '5',
                    },
                    {
                        fh: '1',
                        sh: '10',
                        type: 'attemptsConcededIbox',
                        value: '11',
                    },
                    {
                        fh: '2',
                        sh: '0',
                        type: 'effectiveHeadClearance',
                        value: '2',
                    },
                    {
                        fh: '54',
                        sh: '36',
                        type: 'passesLeft',
                        value: '90',
                    },
                    {
                        fh: '6',
                        sh: '6',
                        type: 'totalAttAssist',
                        value: '12',
                    },
                    {
                        fh: '3',
                        sh: '6',
                        type: 'goalKicks',
                        value: '9',
                    },
                    {
                        fh: '2',
                        sh: '4',
                        type: 'totalCornersIntobox',
                        value: '6',
                    },
                    {
                        fh: '3',
                        sh: '8',
                        type: 'fkFoulWon',
                        value: '11',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'totalOffside',
                        value: '1',
                    },
                    {
                        fh: '105',
                        sh: '66',
                        type: 'leftsidePass',
                        value: '171',
                    },
                    {
                        fh: '6',
                        sh: '2',
                        type: 'attObxCentre',
                        value: '8',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'attMissLeft',
                        value: '2',
                    },
                    {
                        fh: '270',
                        sh: '179',
                        type: 'successfulOpenPlayPass',
                        value: '449',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'divingSave',
                        value: '2',
                    },
                    {
                        fh: '2',
                        sh: '2',
                        type: 'attLfTotal',
                        value: '4',
                    },
                    {
                        fh: '4',
                        sh: '2',
                        type: 'attOboxBlocked',
                        value: '6',
                    },
                    {
                        fh: '88',
                        sh: '72',
                        type: 'fwdPass',
                        value: '160',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'accurateCrossNocorner',
                        value: '2',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'keeperThrows',
                        value: '2',
                    },
                    {
                        fh: '3',
                        sh: '6',
                        type: 'attemptsIbox',
                        value: '9',
                    },
                    {
                        fh: '104',
                        sh: '99',
                        type: 'accurateBackZonePass',
                        value: '203',
                    },
                    {
                        fh: '0',
                        sh: '6',
                        type: 'totalYellowCard',
                        value: '6',
                    },
                    {
                        fh: '6',
                        sh: '2',
                        type: 'attemptsObox',
                        value: '8',
                    },
                    {
                        fh: '1',
                        sh: '2',
                        type: 'attMissRight',
                        value: '3',
                    },
                    {
                        fh: '47',
                        sh: '26',
                        type: 'backwardPass',
                        value: '73',
                    },
                    {
                        fh: '276',
                        sh: '195',
                        type: 'accuratePass',
                        value: '471',
                    },
                    {
                        fh: '4',
                        sh: '3',
                        type: 'effectiveClearance',
                        value: '7',
                    },
                    {
                        fh: '1',
                        sh: '4',
                        type: 'wonContest',
                        value: '5',
                    },
                    {
                        fh: '2',
                        sh: '4',
                        type: 'cornerTaken',
                        value: '6',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'accurateKeeperSweeper',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'attHdMiss',
                        value: '2',
                    },
                    {
                        fh: '0',
                        sh: '5',
                        type: 'subsMade',
                        value: '5',
                    },
                    {
                        fh: '12',
                        sh: '5',
                        type: 'totalThrows',
                        value: '17',
                    },
                    {
                        fh: '58.8',
                        sh: '51.5',
                        type: 'possessionPercentage',
                        value: '55.5',
                    },
                    {
                        fh: '2',
                        sh: '1',
                        type: 'fouledFinalThird',
                        value: '3',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'clearanceOffLine',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'attCmissLeft',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'lastManTackle',
                        value: '1',
                    },
                    {
                        fh: '173',
                        sh: '99',
                        type: 'accurateFwdZonePass',
                        value: '272',
                    },
                    {
                        fh: '3',
                        sh: '4',
                        type: 'offtargetAttAssist',
                        value: '7',
                    },
                    {
                        fh: '43',
                        sh: '29',
                        type: 'finalThirdEntries',
                        value: '72',
                    },
                    {
                        fh: '9',
                        sh: '10',
                        type: 'possWonDef3rd',
                        value: '19',
                    },
                    {
                        fh: '13',
                        sh: '11',
                        type: 'totalCross',
                        value: '24',
                    },
                    {
                        fh: '2',
                        sh: '3',
                        type: 'challengeLost',
                        value: '5',
                    },
                    {
                        fh: '7',
                        sh: '4',
                        type: 'totalLaunches',
                        value: '11',
                    },
                    {
                        fh: '8',
                        sh: '4',
                        type: 'crosses18yard',
                        value: '12',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'sixYardBlock',
                        value: '1',
                    },
                    {
                        fh: '10',
                        sh: '11',
                        type: 'totalTackle',
                        value: '21',
                    },
                    {
                        fh: '9',
                        sh: '8',
                        type: 'totalScoringAtt',
                        value: '17',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'contentiousDecision',
                        value: '1',
                    },
                    {
                        fh: '3',
                        sh: '2',
                        type: 'ontargetAttAssist',
                        value: '5',
                    },
                    {
                        fh: '5',
                        sh: '7',
                        type: 'putThrough',
                        value: '12',
                    },
                    {
                        fh: '7',
                        sh: '8',
                        type: 'aerialWon',
                        value: '15',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attIboxBlocked',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'goalsConceded',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '3',
                        type: 'attCorner',
                        value: '4',
                    },
                    {
                        fh: '2',
                        sh: '2',
                        type: 'attMissHigh',
                        value: '4',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'totalHighClaim',
                        value: '1',
                    },
                    {
                        fh: '10',
                        sh: '9',
                        type: 'accurateChippedPass',
                        value: '19',
                    },
                    {
                        fh: '234',
                        sh: '130',
                        type: 'totalFwdZonePass',
                        value: '364',
                    },
                    {
                        fh: '43',
                        sh: '25',
                        type: 'passesRight',
                        value: '68',
                    },
                    {
                        fh: '1',
                        sh: '5',
                        type: 'accurateGoalKicks',
                        value: '6',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'attSvLowCentre',
                        value: '1',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'lostCorners',
                        value: '1',
                    },
                    {
                        fh: '0',
                        sh: '4',
                        type: 'savedIbox',
                        value: '4',
                    },
                    {
                        fh: '4',
                        sh: '3',
                        type: 'attemptsConcededObox',
                        value: '7',
                    },
                    {
                        fh: '21',
                        sh: '17',
                        type: 'touchesInOppBox',
                        value: '38',
                    },
                    {
                        fh: '8',
                        sh: '6',
                        type: 'aerialLost',
                        value: '14',
                    },
                    {
                        fh: '4',
                        sh: '5',
                        type: 'shotOffTarget',
                        value: '9',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'accurateLaunches',
                        value: '1',
                    },
                    {
                        fh: '2',
                        sh: '5',
                        type: 'attBxCentre',
                        value: '7',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'attBxRight',
                        value: '1',
                    },
                    {
                        fh: '6',
                        sh: '4',
                        type: 'attRfTotal',
                        value: '10',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'savedObox',
                        value: '1',
                    },
                    {
                        type: 'formationUsed',
                        value: '3421',
                    },
                ],
                kit: {
                    id: '4782',
                    colour1: '#FF0000',
                    colour2: '#FFFFFF',
                    type: 'home',
                },
            },
            {
                contestantId: '22doj4sgsocqpxw45h607udje',
                formationUsed: '3421',
                teamOfficial: {
                    id: '2t14kex330qljt5vlmssvo6ad',
                    firstName: 'Antonio',
                    lastName: 'Conte Cavaliere',
                    type: 'manager',
                },
                stat: [
                    {
                        fh: '26',
                        sh: '22',
                        type: 'longPassOwnToOpp',
                        value: '48',
                    },
                    {
                        fh: '11',
                        sh: '6',
                        type: 'interceptionWon',
                        value: '17',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'attCmissRight',
                        value: '2',
                    },
                    {
                        fh: '166',
                        sh: '126',
                        type: 'totalBackZonePass',
                        value: '292',
                    },
                    {
                        fh: '17',
                        sh: '24',
                        type: 'duelWon',
                        value: '41',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'attSvLowLeft',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '2',
                        type: 'possWonAtt3rd',
                        value: '3',
                    },
                    {
                        fh: '0',
                        sh: '3',
                        type: 'attLfTarget',
                        value: '3',
                    },
                    {
                        fh: '16',
                        sh: '13',
                        type: 'longPassOwnToOppSuccess',
                        value: '29',
                    },
                    {
                        fh: '5',
                        sh: '5',
                        type: 'blockedPass',
                        value: '10',
                    },
                    {
                        fh: '4',
                        sh: '3',
                        type: 'outfielderBlock',
                        value: '7',
                    },
                    {
                        fh: '16',
                        sh: '9',
                        type: 'totalClearance',
                        value: '25',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'forwardGoals',
                        value: '2',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attLgCentre',
                        value: '1',
                    },
                    {
                        fh: '7',
                        sh: '4',
                        type: 'effectiveHeadClearance',
                        value: '11',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'goalAssist',
                        value: '2',
                    },
                    {
                        fh: '3',
                        sh: '6',
                        type: 'attemptsConcededIbox',
                        value: '9',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'accurateThroughBall',
                        value: '1',
                    },
                    {
                        fh: '2',
                        sh: '0',
                        type: 'interceptionsInBox',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '4',
                        type: 'attIboxMiss',
                        value: '5',
                    },
                    {
                        fh: '7',
                        sh: '7',
                        type: 'dispossessed',
                        value: '14',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'bigChanceCreated',
                        value: '1',
                    },
                    {
                        fh: '4',
                        sh: '9',
                        type: 'fkFoulLost',
                        value: '13',
                    },
                    {
                        fh: '34',
                        sh: '55',
                        type: 'totalFinalThirdPasses',
                        value: '89',
                    },
                    {
                        fh: '224',
                        sh: '202',
                        type: 'openPlayPass',
                        value: '426',
                    },
                    {
                        fh: '2',
                        sh: '2',
                        type: 'accurateCross',
                        value: '4',
                    },
                    {
                        fh: '25',
                        sh: '24',
                        type: 'totalLongBalls',
                        value: '49',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attOboxTarget',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '6',
                        type: 'ontargetScoringAtt',
                        value: '7',
                    },
                    {
                        fh: '2',
                        sh: '2',
                        type: 'crosses18yardplus',
                        value: '4',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'saves',
                        value: '1',
                    },
                    {
                        fh: '2',
                        sh: '9',
                        type: 'attAssistOpenplay',
                        value: '11',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attHdTotal',
                        value: '1',
                    },
                    {
                        fh: '69',
                        sh: '63',
                        type: 'possLostAll',
                        value: '132',
                    },
                    {
                        fh: '23',
                        sh: '40',
                        type: 'successfulFinalThirdPasses',
                        value: '63',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'goodHighClaim',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'totalFastbreak',
                        value: '2',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'accurateFlickOn',
                        value: '1',
                    },
                    {
                        fh: '5',
                        sh: '12',
                        type: 'attOpenplay',
                        value: '17',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'handBall',
                        value: '2',
                    },
                    {
                        fh: '232',
                        sh: '218',
                        type: 'totalPass',
                        value: '450',
                    },
                    {
                        fh: '7',
                        sh: '4',
                        type: 'headClearance',
                        value: '11',
                    },
                    {
                        fh: '21',
                        sh: '31',
                        type: 'duelLost',
                        value: '52',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'totalFlickOn',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '3',
                        type: 'blockedScoringAtt',
                        value: '4',
                    },
                    {
                        fh: '69',
                        sh: '63',
                        type: 'possLostCtrl',
                        value: '132',
                    },
                    {
                        fh: '36',
                        sh: '27',
                        type: 'ballRecovery',
                        value: '63',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'totalKeeperSweeper',
                        value: '1',
                    },
                    {
                        fh: '17',
                        sh: '17',
                        type: 'totalChippedPass',
                        value: '34',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'successfulPutThrough',
                        value: '1',
                    },
                    {
                        fh: '5',
                        sh: '7',
                        type: 'totalContest',
                        value: '12',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'goalAssistOpenplay',
                        value: '2',
                    },
                    {
                        fh: '6',
                        sh: '5',
                        type: 'unsuccessfulTouch',
                        value: '11',
                    },
                    {
                        fh: '324',
                        sh: '315',
                        type: 'touches',
                        value: '639',
                    },
                    {
                        fh: '2',
                        sh: '3',
                        type: 'accurateKeeperThrows',
                        value: '5',
                    },
                    {
                        fh: '3',
                        sh: '4',
                        type: 'wonTackle',
                        value: '7',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'goalsOpenplay',
                        value: '2',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'bigChanceScored',
                        value: '1',
                    },
                    {
                        fh: '7',
                        sh: '9',
                        type: 'accurateThrows',
                        value: '16',
                    },
                    {
                        fh: '0',
                        sh: '4',
                        type: 'attIboxTarget',
                        value: '4',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'penaltyWon',
                        value: '1',
                    },
                    {
                        fh: '3',
                        sh: '6',
                        type: 'penAreaEntries',
                        value: '9',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'attRfGoal',
                        value: '1',
                    },
                    {
                        fh: '2',
                        sh: '2',
                        type: 'attemptedTackleFoul',
                        value: '4',
                    },
                    {
                        fh: '9',
                        sh: '11',
                        type: 'accurateLongBalls',
                        value: '20',
                    },
                    {
                        fh: '55',
                        sh: '59',
                        type: 'rightsidePass',
                        value: '114',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'wonCorners',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'goals',
                        value: '2',
                    },
                    {
                        fh: '7',
                        sh: '7',
                        type: 'possWonMid3rd',
                        value: '14',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'goalAssistIntentional',
                        value: '1',
                    },
                    {
                        fh: '11',
                        sh: '6',
                        type: 'interception',
                        value: '17',
                    },
                    {
                        fh: '4',
                        sh: '5',
                        type: 'totalCrossNocorner',
                        value: '9',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'attRfTarget',
                        value: '2',
                    },
                    {
                        fh: '2',
                        sh: '0',
                        type: 'attOboxMiss',
                        value: '2',
                    },
                    {
                        fh: '2',
                        sh: '4',
                        type: 'lostCorners',
                        value: '6',
                    },
                    {
                        fh: '0',
                        sh: '3',
                        type: 'attSvLowCentre',
                        value: '3',
                    },
                    {
                        fh: '3',
                        sh: '4',
                        type: 'accurateGoalKicks',
                        value: '7',
                    },
                    {
                        fh: '6',
                        sh: '2',
                        type: 'attemptsConcededObox',
                        value: '8',
                    },
                    {
                        fh: '8',
                        sh: '17',
                        type: 'touchesInOppBox',
                        value: '25',
                    },
                    {
                        fh: '0',
                        sh: '3',
                        type: 'attBxCentre',
                        value: '3',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attPenTarget',
                        value: '1',
                    },
                    {
                        fh: '3',
                        sh: '4',
                        type: 'shotOffTarget',
                        value: '7',
                    },
                    {
                        type: 'cleanSheet',
                        value: '1',
                    },
                    {
                        fh: '7',
                        sh: '8',
                        type: 'aerialLost',
                        value: '15',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attGoalLowRight',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'savedObox',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'attGoalLowLeft',
                        value: '1',
                    },
                    {
                        fh: '4',
                        sh: '6',
                        type: 'attRfTotal',
                        value: '10',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attCmissHighLeft',
                        value: '1',
                    },
                    {
                        fh: '0',
                        sh: '4',
                        type: 'attBxRight',
                        value: '4',
                    },
                    {
                        fh: '4',
                        sh: '5',
                        type: 'totalLaunches',
                        value: '9',
                    },
                    {
                        fh: '1',
                        sh: '4',
                        type: 'challengeLost',
                        value: '5',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'totalThroughBall',
                        value: '1',
                    },
                    {
                        fh: '5',
                        sh: '5',
                        type: 'putThrough',
                        value: '10',
                    },
                    {
                        fh: '2',
                        sh: '6',
                        type: 'ontargetAttAssist',
                        value: '8',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attIboxBlocked',
                        value: '1',
                    },
                    {
                        fh: '8',
                        sh: '6',
                        type: 'aerialWon',
                        value: '14',
                    },
                    {
                        fh: '6',
                        sh: '7',
                        type: 'totalTackle',
                        value: '13',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'punches',
                        value: '1',
                    },
                    {
                        fh: '2',
                        sh: '3',
                        type: 'crosses18yard',
                        value: '5',
                    },
                    {
                        fh: '5',
                        sh: '13',
                        type: 'totalScoringAtt',
                        value: '18',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'totalHighClaim',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'attMissHigh',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'shotFastbreak',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'attOboxGoal',
                        value: '1',
                    },
                    {
                        fh: '6',
                        sh: '7',
                        type: 'accurateChippedPass',
                        value: '13',
                    },
                    {
                        fh: '16',
                        sh: '26',
                        type: 'passesRight',
                        value: '42',
                    },
                    {
                        fh: '70',
                        sh: '98',
                        type: 'totalFwdZonePass',
                        value: '168',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attMissHighLeft',
                        value: '1',
                    },
                    {
                        fh: '2',
                        sh: '2',
                        type: 'attMissRight',
                        value: '4',
                    },
                    {
                        fh: '4',
                        sh: '3',
                        type: 'attemptsObox',
                        value: '7',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'attBxLeft',
                        value: '2',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'totalYellowCard',
                        value: '1',
                    },
                    {
                        fh: '16',
                        sh: '9',
                        type: 'effectiveClearance',
                        value: '25',
                    },
                    {
                        fh: '184',
                        sh: '180',
                        type: 'accuratePass',
                        value: '364',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'cornerTaken',
                        value: '1',
                    },
                    {
                        fh: '2',
                        sh: '3',
                        type: 'wonContest',
                        value: '5',
                    },
                    {
                        type: 'firstHalfGoals',
                        value: '1',
                    },
                    {
                        fh: '33',
                        sh: '28',
                        type: 'backwardPass',
                        value: '61',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'fouledFinalThird',
                        value: '2',
                    },
                    {
                        fh: '41.2',
                        sh: '48.5',
                        type: 'possessionPercentage',
                        value: '44.5',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'bigChanceMissed',
                        value: '1',
                    },
                    {
                        fh: '0',
                        sh: '4',
                        type: 'subsMade',
                        value: '4',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attHdGoal',
                        value: '1',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'accurateKeeperSweeper',
                        value: '1',
                    },
                    {
                        fh: '7',
                        sh: '12',
                        type: 'totalThrows',
                        value: '19',
                    },
                    {
                        fh: '1',
                        sh: '4',
                        type: 'offtargetAttAssist',
                        value: '5',
                    },
                    {
                        fh: '49',
                        sh: '73',
                        type: 'accurateFwdZonePass',
                        value: '122',
                    },
                    {
                        fh: '4',
                        sh: '6',
                        type: 'totalCross',
                        value: '10',
                    },
                    {
                        fh: '24',
                        sh: '13',
                        type: 'possWonDef3rd',
                        value: '37',
                    },
                    {
                        fh: '12',
                        sh: '28',
                        type: 'finalThirdEntries',
                        value: '40',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'effectiveBlockedCross',
                        value: '2',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attIboxGoal',
                        value: '1',
                    },
                    {
                        fh: '3',
                        sh: '10',
                        type: 'totalAttAssist',
                        value: '13',
                    },
                    {
                        fh: '10',
                        sh: '30',
                        type: 'passesLeft',
                        value: '40',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'totalCornersIntobox',
                        value: '1',
                    },
                    {
                        fh: '5',
                        sh: '5',
                        type: 'goalKicks',
                        value: '10',
                    },
                    {
                        fh: '4',
                        sh: '2',
                        type: 'attObxCentre',
                        value: '6',
                    },
                    {
                        fh: '1',
                        sh: '1',
                        type: 'attFastbreak',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'attCmissHigh',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '2',
                        type: 'totalOffside',
                        value: '3',
                    },
                    {
                        fh: '65',
                        sh: '60',
                        type: 'leftsidePass',
                        value: '125',
                    },
                    {
                        fh: '1',
                        sh: '8',
                        type: 'fkFoulWon',
                        value: '9',
                    },
                    {
                        fh: '1',
                        sh: '2',
                        type: 'attOboxBlocked',
                        value: '3',
                    },
                    {
                        fh: '1',
                        sh: '6',
                        type: 'attLfTotal',
                        value: '7',
                    },
                    {
                        fh: '0',
                        sh: '1',
                        type: 'attMissLeft',
                        value: '1',
                    },
                    {
                        fh: '1',
                        sh: '0',
                        type: 'divingSave',
                        value: '1',
                    },
                    {
                        fh: '178',
                        sh: '167',
                        type: 'successfulOpenPlayPass',
                        value: '345',
                    },
                    {
                        fh: '0',
                        sh: '2',
                        type: 'blockedCross',
                        value: '2',
                    },
                    {
                        fh: '1',
                        sh: '10',
                        type: 'attemptsIbox',
                        value: '11',
                    },
                    {
                        fh: '137',
                        sh: '109',
                        type: 'accurateBackZonePass',
                        value: '246',
                    },
                    {
                        fh: '2',
                        sh: '2',
                        type: 'accurateCrossNocorner',
                        value: '4',
                    },
                    {
                        fh: '79',
                        sh: '71',
                        type: 'fwdPass',
                        value: '150',
                    },
                    {
                        fh: '4',
                        sh: '3',
                        type: 'keeperThrows',
                        value: '7',
                    },
                    {
                        type: 'formationUsed',
                        value: '3421',
                    },
                ],
                kit: {
                    id: '4',
                    colour1: '#FFFFFF',
                    colour2: '#132257',
                    type: 'home',
                },
            },
        ],
        matchDetailsExtra: {
            attendance: '29296',
            matchOfficial: [
                {
                    id: '3oe7osb8o3cy0dgex37asng0l',
                    type: 'Main',
                    firstName: 'Craig',
                    lastName: 'Pawson',
                },
                {
                    id: 'f1g3337l5j65736o54oswmxud',
                    type: 'Lineman 1',
                    firstName: 'Ian',
                    lastName: 'Hussin',
                },
                {
                    id: '9fqj6o3vtcziwj0xpzy4e6j85',
                    type: 'Lineman 2',
                    firstName: 'Scott',
                    lastName: 'Ledger',
                },
                {
                    id: '6l3ie5htdymg13u2ui69wo251',
                    type: 'Fourth official',
                    firstName: 'Darren',
                    lastName: 'England',
                },
            ],
        },
    },
}
